/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IContactRemoveMutationVariables = Types.Exact<{
  contactId: Types.Scalars['ID']['input'];
}>;

export type IContactRemoveMutation = {
  __typename?: 'Mutation';
  contactRemove?: {
    __typename?: 'ContactRemovePayload';
    success: boolean;
    errors?: Array<string> | null;
    escrow?:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          depositorConfigured: boolean;
          beneficiaryConfigured: boolean;
          agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          depositorConfigured: boolean;
          beneficiaryConfigured: boolean;
          agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          depositorConfigured: boolean;
          beneficiaryConfigured: boolean;
          agreement: { __typename?: 'Agreement'; policy: { __typename?: 'AgreementPolicy'; generate: boolean } };
        }
      | null;
  } | null;
};

export const ContactRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'contactRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactRemove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contactId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contactId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositorConfigured' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'beneficiaryConfigured' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'policy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'generate' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IContactRemoveMutation, IContactRemoveMutationVariables>;
